import { get,post,put,deleteReq } from "../../../../common/utils/index.js";
import * as AdminPPType from "../../actiontype/AdminPPType/AdminPPType.jsx";


export const onJustReducerUpdate = (payload, reducerType) => {
  return ({ type: reducerType, payload })
}

export const AdminPPList = (headers,showLoader,hideLoader,showToast,dataTrans) => (dispatch) => {

  showLoader();
  dispatch({ type: AdminPPType.ADMINPP_LIST_REQUEST })
  get(`/User`,headers)

    .then(res => {
      hideLoader();
      dispatch({ type: AdminPPType.ADMINPP_LIST_SUCCESS, payload: res.data })
    })
    .catch(err => {
      hideLoader();
      dispatch({ type: AdminPPType.ADMINPP_LIST_FAILURE, payload: err?.message })
      showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
    })
}

export const createAdminPP = (payload,headers,showLoader,hideLoader,showToast, setIsSuccess,roleId,dataTrans) => (dispatch) => {
  showLoader();
  dispatch({ type: AdminPPType.ADMINPP_ADD_REQUEST })
 
  post('/User',payload,headers)
    .then(res => {
      dispatch({ type: AdminPPType.ADMINPP_ADD_SUCCESS, payload: res.data })
      hideLoader();
      var headers={
        pageNo:1,
        pageSize:10,
        AccessIdentifier:'Validate' ,
        RoleId:roleId

      }
      dispatch(AdminPPList(headers,showLoader,hideLoader,showToast,dataTrans));
      setIsSuccess(true);
      showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
      
    })
    .catch(err => {
      hideLoader();
      
      dispatch({ type: AdminPPType.ADMINPP_ADD_FAILURE, payload: err?.response?.data?.data })
      showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
    })
}


export const updateAdminPP = (updateObject,setOtpCodeFlag,setIsModalOpen) => (dispatch) => {
  updateObject.showLoader();
  dispatch({ type: AdminPPType.ADMINPP_EDIT_REQUEST })
 
  put(`/User/${updateObject.id}`,updateObject.payloadUpdate,updateObject.headers)
    .then(res => {
      updateObject.hideLoader();
      if(updateObject?.updateFirst==true){
        updateObject.setIsEditOpen(false)
        updateObject.setOtpSelectionFlag(true)
      }
      // setOtpSelectionFlag(true)
      if(updateObject.updateHeader==true){
      
        setIsModalOpen(false)
        updateObject.setOtpSelectionFlag(true)
      }
      setOtpCodeFlag(false)
      dispatch({ type: AdminPPType.ADMINPP_EDIT_SUCCESS, payload: res.data })
      // var headers={
      //   pageNo:1,
      //   pageSize:10,
      //   Accessidentifier :'Validate' 
      // }
      var headersGet={
        pageNo:1,
        pageSize:10,
        AccessIdentifier:'Validate',
        RoleId:updateObject?.menuRoleId
      }
    
      updateObject.showToast('success',updateObject.t('text_toast_success'),res?.response?.data?.message);
      // setOtpCodeFlag(false)
      dispatch(AdminPPList(headersGet,updateObject.showLoader,updateObject.hideLoader,updateObject.showToast,updateObject.t));
      //  updateObject.setOtpCodeFlag(false);
      //  updateObject.setIsEditOpen(false)
   
      
    })
    .catch(err => {
      updateObject.hideLoader();
      if(err?.response?.data?.StatusCode===403){
        updateObject.showToast('warn','Warning', 'OTP non valido')
     }else{
      updateObject.showToast('warn','Warning', updateObject.t(err?.response?.data?.message));
     }
      dispatch({ type: AdminPPType.ADMINPP_EDIT_FAILURE, payload: err?.message })
      // setOtpCodeFlag(true)
      // updateObject.setOtpCodeFlag(true)
      // setIsSuccess(true);
      // updateObject.showToast('warn','Attenzione',updateObject.t(err?.response?.data?.message));
    })
}

export const getByIdUser = (headers,showLoader,hideLoader,showToast,idValueUser) => (dispatch) => {

  let id=localStorage.getItem('userId')

  let roleId=localStorage.getItem('roleId')
  let value=idValueUser ? idValueUser :roleId
  showLoader();
  dispatch({ type: AdminPPType.ADMINPP_GETID_REQUEST })
 
  get(`/User/${id}?roleId=${value}`,headers)
    .then(res => {
      hideLoader();
      dispatch({ type: AdminPPType.ADMINPP_GETID_SUCCESS, payload: res.data })
      // setOtpCodeFlag(false)
      // setIsModalOpen(true)
      
    })
    .catch(err => {
      hideLoader();
      dispatch({ type: AdminPPType.ADMINPP_GETID_FAILURE, payload: err?.message })
      // showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
    })
}

export const updateStatusUser = (id, payload, header,roleId, showLoader, hideLoader, showToast,dataTrans) => (dispatch) => {


  showLoader();
  dispatch({ type: AdminPPType.ADMIN_STATUS_REQUEST })

  put(`/User/UpdateStatus/${id}`, payload, header)
    .then(res => {
      hideLoader();
      dispatch({ type: AdminPPType.ADMINPP_STATUS_SUCCESS, payload: res.data })
      var headers={
        pageNo:1,
        pageSize:10,
        AccessIdentifier:'Validate' ,
        RoleId:roleId

      }
      dispatch(AdminPPList(headers,showLoader,hideLoader));
      // dispatch(getByPatientId(id, showLoader, hideLoader))
      showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
    })
    .catch(err => {
      hideLoader();
      dispatch({ type: AdminPPType.ADMINPP_STATUS_FAILURE, payload: err?.message })
      showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
    })
}

export const deleteUser= (id,roleId,showLoader,hideLoader,showToast,dataTrans) => (dispatch) => {
  showLoader();
  dispatch({ type: AdminPPType.ADMIN_DELETE_REQUEST })
  deleteReq(`/User/${id}?roleId=${roleId}`)
      .then(res => {
          dispatch({ type: AdminPPType.ADMINPP_DELETE_SUCCESS, payload: res })
          hideLoader();
          var headers={
            pageNo:1,
            pageSize:10,
            AccessIdentifier:'Validate' ,
            RoleId:roleId
          }
          dispatch(AdminPPList(headers,showLoader,hideLoader));
          showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
      })
      .catch(err => {
       hideLoader();
       dispatch({ type: AdminPPType.ADMINPP_DELETE_FAILURE, payload:err?.response?.data?.message})
       showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
      })
}

export const onAdminPPReducerUpdate = (payload, reducerType) => {
    return ({ type: reducerType, payload })
  }
